<div class="wrapper">
  <mat-form-field class="filterField">
    <mat-label>Filtrer</mat-label>
    <input matInput (keyup)="applyFilterTransportType($event)" placeholder="Votre filtre" #input>
  </mat-form-field>

  <table mat-table [dataSource]="dataSource" multiTemplateDataRows matSort #MatSort="matSort">
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'repository.transportTypes.list.name'
        | translate }} </th>
      <td mat-cell *matCellDef="let transportType"> {{ transportType.name }} </td>
    </ng-container>

    <ng-container matColumnDef="dictionary">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Catégorie </th>
      <td mat-cell *matCellDef="let transportType"> {{ transportType.dictionary.description }} </td>
    </ng-container>

    <ng-container matColumnDef="client">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> {{
        'repository.transportTypes.list.client' | translate }} </th>
      <td mat-cell *matCellDef="let transportType"> {{ transportType.client?.name }} </td>
    </ng-container>

    <ng-container matColumnDef="site">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> {{
        'repository.transportTypes.list.site' | translate }} </th>
      <td mat-cell *matCellDef="let transportType"> {{ transportType.site?.name }} </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef> {{ 'repository.transportTypes.list.actions' | translate
        }} </th>
      <td mat-cell *matCellDef="let transportType">
        <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Menu boutons" color="primary">
          <mat-icon>more_vert</mat-icon>
        </button>

        <mat-menu #menu="matMenu">
          <ng-container *ngIf="transportType.id !== editedId">
            <button mat-menu-item class="action-button" [disabled]="isLoading"
              [matTooltip]="'repository.' + dictionary +'.list.edit' | translate" (click)="onEdit(transportType.id)">
              <mat-icon aria-label="Edit" color="primary">edit</mat-icon>
              <span>{{'repository.' + dictionary +'.list.edit' | translate}}</span>
            </button>
          </ng-container>

          <ng-container>
            <button mat-menu-item class="action-button" [disabled]="isLoading"
              [matTooltip]="'repository.' + dictionary +'.list.delete' | translate"
              (click)="deleteDictionaryValue(transportType.id)">
              <mat-icon aria-label="Delete" color="primary">clear</mat-icon>
              <span>{{'repository.' + dictionary +'.list.delete' | translate}}</span>
            </button>
          </ng-container>
        </mat-menu>
      </td>
    </ng-container>

    <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
    <ng-container matColumnDef="expandedDetail">
      <td mat-cell *matCellDef="let transportType" [attr.colspan]="displayedColumns.length">
        <div *ngIf="transportType.id === editedId" class="row-edit"
          [@detailExpand]="transportType.id === editedId ? 'expanded' : 'collapsed'">
          <app-dictionary-edit [dictionaryValue]="transportType" [transportTypes]="transportTypes"
            [urgencyLevels]="urgencyLevels" (editFinished)="onEditFinished()"></app-dictionary-edit>
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="row"
      [ngClass]="{ 'expanded-row': row.id === editedId }"></tr>
    <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="detail-row"></tr>
  </table>

  <mat-paginator class="paginator" [pageSizeOptions]="[20, 25, 50, 100]" showFirstLastButtons
    #MatPaginator></mat-paginator>
</div>